// extracted by css-extract-rspack-plugin
export default {"cls1":"BundleGrid-cls1_Jht","cls2":"BundleGrid-cls2_S_3 BundleGrid-cls1_Jht"};